var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBricklaying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 14.5,
    className: "st0",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.5,22h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C36,21.78,35.78,22,35.5,22z M22,21h13v-6H22V21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 14.5,
    className: "st0",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,22h-14C7.22,22,7,21.78,7,21.5v-7C7,14.22,7.22,14,7.5,14h14c0.28,0,0.5,0.22,0.5,0.5v7 C22,21.78,21.78,22,21.5,22z M8,21h13v-6H8V21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 14.5,
    className: "st0",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,22h-7C0.22,22,0,21.78,0,21.5v-7C0,14.22,0.22,14,0.5,14h7C7.78,14,8,14.22,8,14.5v7 C8,21.78,7.78,22,7.5,22z M1,21h6v-6H1V21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 21.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.5,29h-14C0.22,29,0,28.78,0,28.5v-7C0,21.22,0.22,21,0.5,21h14c0.28,0,0.5,0.22,0.5,0.5v7 C15,28.78,14.78,29,14.5,29z M1,28h13v-6H1V28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 21.5,
    className: "st0",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,29h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C29,28.78,28.78,29,28.5,29z M15,28h13v-6H15V28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 21.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,29h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C43,28.78,42.78,29,42.5,29z M29,28h13v-6H29V28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 27.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,35h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C50,34.78,49.78,35,49.5,35z M36,34h13v-6H36V34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 27.5,
    className: "st0",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.5,35h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C36,34.78,35.78,35,35.5,35z M22,34h13v-6H22V34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 27.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,35h-14C7.22,35,7,34.78,7,34.5v-7C7,27.22,7.22,27,7.5,27h14c0.28,0,0.5,0.22,0.5,0.5v7 C22,34.78,21.78,35,21.5,35z M8,34h13v-6H8V34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 27.5,
    className: "st0",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,35h-7C0.22,35,0,34.78,0,34.5v-7C0,27.22,0.22,27,0.5,27h7C7.78,27,8,27.22,8,27.5v7 C8,34.78,7.78,35,7.5,35z M1,34h6v-6H1V34z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 34.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.5,42h-14C0.22,42,0,41.78,0,41.5v-7C0,34.22,0.22,34,0.5,34h14c0.28,0,0.5,0.22,0.5,0.5v7 C15,41.78,14.78,42,14.5,42z M1,41h13v-6H1V41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 34.5,
    className: "st0",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,42h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C29,41.78,28.78,42,28.5,42z M15,41h13v-6H15V41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 34.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,42h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C43,41.78,42.78,42,42.5,42z M29,41h13v-6H29V41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 42.5,
    y: 34.5,
    className: "st0",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,42h-7c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h7c0.28,0,0.5,0.22,0.5,0.5v7 C50,41.78,49.78,42,49.5,42z M43,41h6v-6h-6V41z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 35.5,
    y: 40.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5,48h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C50,47.78,49.78,48,49.5,48z M36,47h13v-6H36V47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 40.5,
    className: "st0",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.5,48h-14c-0.28,0-0.5-0.22-0.5-0.5v-7c0-0.28,0.22-0.5,0.5-0.5h14c0.28,0,0.5,0.22,0.5,0.5v7 C36,47.78,35.78,48,35.5,48z M22,47h13v-6H22V47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 40.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.5,48h-14C7.22,48,7,47.78,7,47.5v-7C7,40.22,7.22,40,7.5,40h14c0.28,0,0.5,0.22,0.5,0.5v7 C22,47.78,21.78,48,21.5,48z M8,47h13v-6H8V47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 40.5,
    className: "st0",
    width: 7,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.5,48h-7C0.22,48,0,47.78,0,47.5v-7C0,40.22,0.22,40,0.5,40h7C7.78,40,8,40.22,8,40.5v7 C8,47.78,7.78,48,7.5,48z M1,47h6v-6H1V47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.38,14.07v8.16c0,1.06-0.68,1.98-1.58,2.14c-0.58,0.1-1.13-0.04-1.57-0.41c-0.46-0.38-0.72-0.95-0.72-1.55 V18.7c0-1.1-0.89-2-1.98-2s-1.98,0.9-1.98,2v0.57c0,1.06-0.68,1.98-1.58,2.14c-0.57,0.1-1.13-0.04-1.57-0.41 c-0.46-0.38-0.72-0.95-0.72-1.55v-1.23c0-1.19-0.96-2.16-2.14-2.16c-0.88,0-1.82,0.57-1.82,2.19v6.57c0,0.89-0.4,1.72-1.05,2.16 c-0.82,0.56-1.64,0.68-2.3,0.33c-0.69-0.36-1.13-1.2-1.13-2.12v-5.26c0-1.1-0.89-2-1.98-2c-1.09,0-1.98,0.9-1.98,2v1.06 c0,0.93-0.94,1.95-1.96,2.13c-0.82,0.15-1.96-0.21-2.73-0.84c-0.15-0.12-0.35-0.33-0.5-0.57v2.65c1.12,0.65,2.46,0.94,3.58,0.74 c1.81-0.33,3.31-1.87,3.57-3.58v3.67c0,1.68,0.84,3.17,2.2,3.89c0.55,0.29,1.13,0.43,1.74,0.43c0.87,0,1.77-0.29,2.62-0.88 c1.2-0.82,1.92-2.25,1.92-3.81v-4.79c0.14,0.98,0.63,1.87,1.4,2.51c0.89,0.75,2.06,1.05,3.21,0.85c1.68-0.3,2.95-1.73,3.19-3.51 v2.53c0,1.2,0.52,2.32,1.44,3.09c0.89,0.75,2.06,1.06,3.21,0.85c1.87-0.34,3.23-2.07,3.23-4.11v-8.16H29.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    className: "st0",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.5,10h-14C0.22,10,0,9.78,0,9.5v-7C0,2.22,0.22,2,0.5,2h14C14.78,2,15,2.22,15,2.5v7 C15,9.78,14.78,10,14.5,10z M1,9h13V3H1V9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 2.5,
    className: "st1",
    width: 14,
    height: 7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.5,10h-14C14.22,10,14,9.78,14,9.5v-7C14,2.22,14.22,2,14.5,2h14C28.78,2,29,2.22,29,2.5v7 C29,9.78,28.78,10,28.5,10z M15,9h13V3H15V9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.5,14.16v7.96c0,1.1-0.9,2-2,2h0c-1.1,0-2-0.9-2-2v-3.7c0-1.1-0.9-2-2-2l0,0c-1.1,0-2,0.9-2,2v0.48 c0,1.1-0.9,2-2,2h0c-1.1,0-2-0.9-2-2v-1.4c0-1.1-0.9-2-2-2h0c-1.1,0-2,0.9-2,2v7.29c0,1.1-0.9,2-2,2h0c-1.1,0-2-0.9-2-2v-5.15 c0-1.1-0.9-2-2-2h0c-1.1,0-2,0.9-2,2v1.19c0,0-1.5,2.09-2.65,2.09l0,0c-1.15,0-2.09-0.94-2.35-2.09v-6.6 c0.26-0.38,0.95-0.74,0.95-0.74h27.4C29.21,13.5,29.5,13.79,29.5,14.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M11.5,27.29c-1.38,0-2.5-1.12-2.5-2.5v-5.15c0-0.83-0.67-1.5-1.5-1.5S6,18.82,6,19.64v1.19 c0,0.1-0.03,0.21-0.09,0.29c-0.27,0.38-1.71,2.3-3.06,2.3c-1.32,0-2.52-1.04-2.84-2.48C0,20.91,0,20.87,0,20.83v-6.6 c0-0.1,0.03-0.2,0.09-0.28c0.31-0.46,0.99-0.83,1.13-0.9C1.29,13.02,1.37,13,1.45,13h27.4c0.64,0,1.16,0.52,1.16,1.16v7.96 c0,1.38-1.12,2.5-2.5,2.5c-1.38,0-2.5-1.12-2.5-2.5v-3.7c0-0.83-0.67-1.5-1.5-1.5s-1.5,0.67-1.5,1.5v0.48c0,1.38-1.12,2.5-2.5,2.5 S17,20.28,17,18.9v-1.4c0-0.83-0.67-1.5-1.5-1.5S14,16.67,14,17.5v7.29C14,26.17,12.88,27.29,11.5,27.29z M7.5,17.14 c1.38,0,2.5,1.12,2.5,2.5v5.15c0,0.83,0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5V17.5c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v1.4 c0,0.83,0.67,1.5,1.5,1.5s1.5-0.67,1.5-1.5v-0.48c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v3.7c0,0.83,0.67,1.5,1.5,1.5 s1.5-0.67,1.5-1.5v-7.96c0-0.09-0.07-0.16-0.16-0.16H1.57C1.38,14.11,1.14,14.27,1,14.42v6.36c0.24,0.96,1.01,1.65,1.85,1.65 c0.59,0,1.57-0.99,2.15-1.75v-1.03C5,18.26,6.12,17.14,7.5,17.14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBricklaying);
export default __webpack_public_path__ + "static/media/bricklaying.f185d56481c686f62c0998b94d30ae68.svg";
export { ForwardRef as ReactComponent };